import "./Video.css";
import sampleVideo from "../assets/Clg Vdo(1).mp4"; // <-- apna video yaha import karein

export default function Video() {
  return (
    <>
      <div className="videomaindv">
        <video className="innerVideo" autoPlay loop muted playsInline>
          <source src={sampleVideo} type="video/mp4" />
        </video>
      </div>
    </>
  );
}
